import { connect } from "react-redux";

import EngagementReportView from "./view.jsx";

import { 
  fetchEngagementAssetViewsGraphReport, 
  fetchEngagementShareGraphReport, 
  fetchEngagementUniqueViewersGraphReport,
  fetchEngagementAttentionTimeGraphReport,

  fetchEngagementPopularAssets,
  fetchEngagementTopUsers,
  fetchEngagementTopAccounts, 
  
  fetchEngagementCampaigns, 
  fetchEngagementCampaignSources,

  fetchEngagementShareReport,
  fetchEngagementCollectionActivityReport,
  intializeDownloadReport
} from '../../../redux/actions/reports.jsx';

import { trackAdoptionMetricsForReportsToggledViewEvent } from "src/legacy/redux/actions/adoption.jsx";

const mapStateToProps = (state, ownProps) => {
  return {
    download: state.legacyRootReducer.reports.download
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchEngagementAssetViewsGraphReport: (filter) => {
      return dispatch(fetchEngagementAssetViewsGraphReport(filter));
    },

    fetchEngagementShareGraphReport: (filter) => {
      return dispatch(fetchEngagementShareGraphReport(filter));
    },

    fetchEngagementUniqueViewersGraphReport: (filter) => {
      return dispatch(fetchEngagementUniqueViewersGraphReport(filter));
    },

    fetchEngagementAttentionTimeGraphReport: (filter) => {
      return dispatch(fetchEngagementAttentionTimeGraphReport(filter));
    },

    fetchEngagementPopularAssets: (filter, page, limit) => {
      return dispatch(fetchEngagementPopularAssets(filter, page, limit));
    },

    fetchEngagementTopUsers: (filter, page, limit) => {
      return dispatch(fetchEngagementTopUsers(filter, page, limit));
    },

    fetchEngagementTopAccounts: (filter, page, limit) => {
      return dispatch(fetchEngagementTopAccounts(filter, page, limit));
    },

    fetchEngagementCampaigns: (filter, page, limit) => {
      return dispatch(fetchEngagementCampaigns(filter, page, limit));
    },

    fetchEngagementCampaignSources: (filter, page, limit) => {
      return dispatch(fetchEngagementCampaignSources(filter, page, limit));
    },

    fetchEngagementShareReport: (filter, page, limit) => {
      return dispatch(fetchEngagementShareReport(filter, page, limit));
    },

    fetchEngagementCollectionActivityReport: (filter, page, limit) => {
      return dispatch(fetchEngagementCollectionActivityReport(filter, page, limit));
    },

    downloadReport: (id, filter, page, limit) => {
      return dispatch(intializeDownloadReport(id, filter, page, limit));
    },
    
    trackAdoptionMetricsForReportsToggledViewEvent: (tabType) => {
      return dispatch(trackAdoptionMetricsForReportsToggledViewEvent(tabType))
    }

  };
};

const EngagementReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(EngagementReportView);

export default EngagementReport;